(() => {
    const event = new CustomEvent('turnstileInit');

    window.onloadTurnstileCallback = () => {
        window.dispatchEvent(event);
    };
})();
